import RegisterSteps from '../registerSteps/registerSteps'
import { getStepsRegisterBodyshop } from '../registerSteps/utilsSteps';
import { TypeRegisterStep } from '../registerSteps/types';
import SrcImageLine from '@/main/assets/images/homepage/line_image_edited_1.png';
import * as S from '../styles';

function RegisterPublicBodyshopScreen() {
  const steps: TypeRegisterStep[] = getStepsRegisterBodyshop();

  return (
    <S.Container>
      <RegisterSteps
        typeRegister='bodyshop'
        orderStepsToRender={steps}
      />
      <S.ImageLine src={SrcImageLine} />
    </S.Container>
  )
}

export default RegisterPublicBodyshopScreen